<div class="flex flex-column p-2 gap-2" [formGroup]="form">
  <app-input-datetime name="dataOraAnalisi" [form]="form" [minDate]="checkPrelievoData!"></app-input-datetime>
  <app-input-text name="numeroRapportoProvaAnalisi" label="N° Rapporto di prova" [form]="form"></app-input-text>
  <app-input-text name="codiceAccrediaLaboratorioAnalisi" label="Codice Accredia del laboratorio" [form]="form"></app-input-text>
</div>
